import { Resource } from 'i18next';
import languages from '../languages';
import home from './home.json';

interface IResource {
  [key: string]: Resource;
}

const mergeResource: IResource = {
  home,
};

export const langs = Object.keys(languages);

const resources: Resource = {};

langs.forEach(lang => {
  Object.keys(mergeResource).map(fileName => {
    resources[lang] = {
      translation: {
        ...(resources[lang]?.translation as object),
        [fileName]: mergeResource[fileName][lang],
      },
    };
  });
});

export default resources;
